import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import { SEO } from '../../components/SEO/SEO';
import './ForBusiness.css';
import dashboard from '../../assets/dash.png';

export const ForBusiness = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="business-page-wrapper">
      <SEO 
        title="Host Events with Hobi Hub | Grow Your Experience Business"
        description="Join Hobi Hub as an organizer. List your workshops, classes, or tours and reach thousands of experience seekers. Manage bookings, payments, and growth with our advanced panel."
        keywords="host events, event organizer, selling workshops, business growth, experience business, Hobi Hub organizer"
        canonicalUrl="https://hobi.co.in/for-business"
      />
      
      <section className='hero-bg'>
        <Navbar dark={false} />
        
        <div className="hero">
          <div className="hero-container">
            <div className="hero-box">
              <div className="hero-center">
                <h1 className="hero-h1" style={{ opacity: 1 }}>Turn Your Passion <br/> Into a Business</h1>
                <div className="home-desc" style={{ opacity: 1 }}>
                  <p className="hero-p">
                    Join the Hobi Hub organizer community. Host unique experiences, reach new audiences, and manage everything seamlessly with our dedicated dashboard.
                  </p>
                </div>
                <div className="hero-cta-group">
                  <a href="https://organizer.hobi.co.in" target="_blank" rel="noopener noreferrer" className="cta-button w-inline-block">
                    <div className="text-block">Get Started Now</div>
                  </a>
                </div>
              </div>
              <div className="hero-bottom" style={{ opacity: 1 }}>
                <img
                  src="/images/bg-edited.svg"
                  loading="lazy"
                  alt="Hobi Hub Business"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- DASHBOARD PREVIEW --- */}
      <section className="dashboard-preview-section listing-section">
        <div className="container-mediumB">
          <div className="preview-layout">
            <div className="preview-text">
              <h3 className="heading-italic">Powerful Management</h3>
              <h2>A Dashboard Built <br/> for Scale</h2>
              <p>
                Manage your entire experience business from one place. Track bookings in real-time, monitor your revenue, and handle withdrawals with a single click. Our intuitive interface lets you focus on what you do best: creating amazing experiences.
              </p>
              <ul className="business-check-list">
                <li>Real-time Booking Notifications</li>
                <li>Advanced Revenue Analytics</li>
                <li>Seamless Multi-event Management</li>
                <li>Direct Bank Payouts</li>
              </ul>
            </div>
            <div className="preview-image-container">
              <img 
                src={dashboard} // This should ideally be a nice mockup, for now I'll use the description of the uploaded image if I can't find a file. Actually I will use a high quality placeholder or a descriptivealt.
                alt="Hobi Hub Organizer Panel Dashboard" 
                className="dashboard-mockup"
              />
              {/* Overlay elements to make it look premium */}
              <div className="glass-overlay-card top-right">
                <div className="dot green"></div>
                <span>Total Earnings: ₹45,290</span>
              </div>
              <div className="glass-overlay-card bottom-left">
                <div className="dot blue"></div>
                <span>New Bookings: 12 Today</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- WHY HOST WITH US --- */}
      <section className="business-features hero-bg-listing-outdoor">
        <div className="container-mediumB">
          <div className="section-header-center">
            <h2 className="title-large">Why Host with Hobi Hub?</h2>
            <p className="subtitle-medium">Everything you need to grow your community and revenue.</p>
          </div>
          <div className="features-grid-premium">
            <div className="biz-feature-card">
              <div className="biz-icon-box pink">
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              </div>
              <h3>Wider Reach</h3>
              <p>Get discovered by thousands of active experience seekers looking for their next hobby in your city.</p>
            </div>
            <div className="biz-feature-card">
              <div className="biz-icon-box green">
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
              </div>
              <h3>Automated Payments</h3>
              <p>No more manual tracking. We handle all payments securely and process payouts directly to your account.</p>
            </div>
            <div className="biz-feature-card">
              <div className="biz-icon-box blue">
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
              </div>
              <h3>Growth Tools</h3>
              <p>Use our built-in marketing tools and insights to optimize your pricing, timing, and content for maximum impact.</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- HOW IT WORKS --- */}
      <section className="how-it-works-biz ">
        <div className="container-mediumB">
          <h2 className="title-large text-center">3 Simple Steps to Start</h2>
          <div className="steps-grid">
            <div className="step-item-biz">
              <div className="step-number">01</div>
              <h3>Create Your Account</h3>
              <p>Sign up as an organizer in less than 2 minutes. No upfront costs or hidden fees.</p>
            </div>
            <div className="step-item-biz">
              <div className="step-number">02</div>
              <h3>List Your Experience</h3>
              <p>Add photos, description, and pricing. Our team will review and publish it within 24 hours.</p>
            </div>
            <div className="step-item-biz">
              <div className="step-number">03</div>
              <h3>Welcome Your Guests</h3>
              <p>Manage bookings from your dashboard and get paid automatically after each successful event.</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- FINAL CTA --- */}
      <section className="business-final-cta hero-bg">
        <div className="container-mediumB">
          <div className="cta-gradient-box">
            <h2 className="white-text">Ready to Host Your First Event?</h2>
            <p className="white-text-opacity">Join 500+ successful organizers on Hobi Hub today.</p>
            <a href="https://organizer.hobi.co.in" target="_blank" rel="noopener noreferrer" className="cta-btn-white">
              Launch Organizer Dashboard
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
